import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GoogleButtonContents, GoogleButtonContentWrapper, GoogleButtonIcon, GoogleButtonState, GoogleSignInButton } from './styled';
import GoogleIcon from '@/shared/assets/icons/GoogleIcon';
function GoogleSignIn({ onClick, title }) {
    return (_jsxs(GoogleSignInButton, { onClick: onClick, children: [_jsx(GoogleButtonState, {}), _jsxs(GoogleButtonContentWrapper, { children: [_jsx(GoogleButtonIcon, { children: _jsx(GoogleIcon, { width: 24, height: 24 }) }), _jsx(GoogleButtonContents, { children: title })] })] }));
}
export default GoogleSignIn;
